<template>
  <v-card class="mb-5">
    <v-card-title>Cashflow Statement</v-card-title>
    <v-card-text>
      <v-row>
        <!-- Report Type -->
        <v-col cols="12" sm="4">
          <v-select
            label="Report Type"
            :items="reportTypes"
            v-model="selectedReportType"
            @change="updateDates"
          ></v-select>
        </v-col>

        <!-- Month (Only for Monthly) -->
        <v-col cols="12" sm="4" v-if="selectedReportType === 'Monthly'">
          <v-select
            label="Month"
            :items="months"
            item-text="text"
            item-value="value"
            v-model="selectedMonth"
            @change="updateDates"
          ></v-select>
        </v-col>

        <!-- Quarter (Only for Quarterly) -->
        <v-col cols="12" sm="4" v-if="selectedReportType === 'Quarterly'">
          <v-select
            label="Quarter"
            :items="quarters"
            v-model="selectedQuarter"
            @change="updateDates"
          ></v-select>
        </v-col>

        <!-- Year (Not for Daily) -->
        <v-col cols="12" sm="4" v-if="selectedReportType !== 'Daily'">
          <v-select
            label="Year"
            :items="years"
            v-model="selectedYear"
            @change="updateDates"
          ></v-select>
        </v-col>

        <!-- Manual Dates (Only for Daily) -->
        <v-col cols="12" sm="4" v-if="selectedReportType === 'Daily'">
          <v-text-field
            label="From Date"
            v-model="form.fromDate"
            type="date"
            @change="updateDates"
          ></v-text-field>
        </v-col>

        <v-col cols="12" sm="4" v-if="selectedReportType === 'Daily'">
          <v-text-field
            label="To Date"
            v-model="form.toDate"
            type="date"
            @change="updateDates"
          ></v-text-field>
        </v-col>
        <v-col cols="12" sm="4">
          <!-- Print Button -->
          <v-btn
            color="primary"
            height="45"
            width="200"
            class="mr-2"
            rounded
            @click="print('cash_flow_statement')"
          >
            Print
          </v-btn></v-col
        >
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import moment from "moment";
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      form: {
        fromDate: "",
        toDate: "",
      },
      selectedReportType: "Monthly", // Default
      selectedMonth: moment().format("MM"),
      selectedQuarter: "Q1",
      selectedYear: moment().format("YYYY"),

      months: [
        { text: "January", value: "01" },
        { text: "February", value: "02" },
        { text: "March", value: "03" },
        { text: "April", value: "04" },
        { text: "May", value: "05" },
        { text: "June", value: "06" },
        { text: "July", value: "07" },
        { text: "August", value: "08" },
        { text: "September", value: "09" },
        { text: "October", value: "10" },
        { text: "November", value: "11" },
        { text: "December", value: "12" },
      ],
      quarters: ["Q1", "Q2", "Q3", "Q4"],
      years: ["2024", "2025", "2026", "2027", "2028"],
      reportTypes: ["Monthly", "Quarterly", "Yearly", "Daily"],
    };
  },
  computed: {
    ...mapGetters({
      user: "auth/user",
      default_server_url: "auth/default_server_url",
    }),
  },
  methods: {
    updateDates() {
      const year = this.selectedYear;
      let fromDate = "";
      let toDate = "";

      switch (this.selectedReportType) {
        case "Monthly": {
          const month = this.selectedMonth;
          fromDate = moment(`${year}-${month}-01`)
            .startOf("month")
            .format("YYYY-MM-DD");
          toDate = moment(`${year}-${month}-01`)
            .endOf("month")
            .format("YYYY-MM-DD");
          break;
        }
        case "Quarterly": {
          let startMonth;
          let endMonth;
          switch (this.selectedQuarter) {
            case "Q1":
              startMonth = "01";
              endMonth = "03";
              break;
            case "Q2":
              startMonth = "04";
              endMonth = "06";
              break;
            case "Q3":
              startMonth = "07";
              endMonth = "09";
              break;
            case "Q4":
              startMonth = "10";
              endMonth = "12";
              break;
          }
          fromDate = moment(`${year}-${startMonth}-01`)
            .startOf("month")
            .format("YYYY-MM-DD");
          toDate = moment(`${year}-${endMonth}-01`)
            .endOf("month")
            .format("YYYY-MM-DD");
          break;
        }
        case "Yearly": {
          fromDate = moment(`${year}-01-01`)
            .startOf("year")
            .format("YYYY-MM-DD");
          toDate = moment(`${year}-12-31`).endOf("year").format("YYYY-MM-DD");
          break;
        }
      }

      this.form.fromDate = fromDate;
      this.form.toDate = toDate;
    },

    print() {
      if (!this.form.fromDate || !this.form.toDate) {
        return alert("Please select a date range first");
      }
      if (window.confirm("Are you sure you want to print this report?")) {
        const url = `${this.default_server_url}/cash_flow_statement/${this.form.fromDate}/${this.form.toDate}/${this.user.branch_id}`;
        window.open(url);
      }
    },
  },
  created() {
    this.updateDates(); // Auto-set initial range
  },
};
</script>
